<template>
  <div class="mylesson">
    <my-study-nav></my-study-nav>
    <div class="content-right">
      <h2 class="top-title">直播测试</h2>
      <div class="live-block" style="height:190px;margin-top:10px">
        <h2 class="live-block-title">直播上课测试</h2>
        <p class="live-block-row">
          <span class="row-left"><span style="font-weight:bold">1.</span>填写直播码和客服测试:</span>
          <input v-model="inputValue" class="code-input" type="text" :placeholder="placeholdertext" @focus="hideplaceholder" @blur="showplaceholder">
          <button class="confirm-enter-btn" @click="golive2()">确定进入</button>
        </p>
        <p class="hint">添加客服微信号，向客服询问<span class="color">直播码，</span>然后输入进入直播间和客服测试上课</p>
      </div>
      <div class="live-block" style="margin-top:10px;height:356px">
        <h2 class="live-block-title">客服微信</h2>
        <p class="live-block-row">
          <span class="row-left"><span style="font-weight:bold">1.</span>全优在线客服微信号:</span>
          <span class="row-number-text">0571-28815085</span>
        </p>
        <p class="live-block-row">
          <span class="row-left" style="margin-right:2px"><span style="font-weight:bold">2.</span>全优在线客服微信二维码:</span>
          <img src="./quanyouerweima.jpg" alt="qrcode" width="156" height="156">
          <span class="scan">扫描微信二维码添加客服</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import MyStudyNav from 'components/mystudynav/MyStudyNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        inputValue:'',
        placeholdertext:'请填写客服给的直播码',
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      hideplaceholder(){
        this.placeholdertext='';
      },
      showplaceholder(){
        this.placeholdertext='请填写客服给的直播码';
      },
      golive2(){
        let id = this.id;
        if(id==null){
          this.$message({
            message:'请先登录',
            type:'warning'
          })
          return;
        }
        let code=this.inputValue;
        if(code==''){
          this.$message({
            message:'请输入直播码',
            type:'warning'
          })
          return;
        }
        window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&code=${code}&roomtype=2`);
      }
    },
    created(){

    },
    components: {
      MyStudyNav,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .mylesson
    margin: 10px auto 40px
    width: 1226px
    min-height: calc(100vh - 385px)
    box-sizing border-box
    overflow: hidden
    .content-right
      float: right
      width: 966px
      .top-title {
        height: 68px
        line-height: 68px;
        padding-left: 20px;
        font-size: 24px;
        font-weight: bold
        color: #333;
        background: #fff;
      }
      .live-block
        padding-top: 20px
        background: #ffffff
        box-sizing: border-box
        .live-block-title {
          margin: 0 0 0 30px
          padding-left: 14px
          font-size: 20px
          height: 28px
          line-height: 28px
          color: #333333
          font-weight: bold
          position: relative
          &::before {
            content: ' '
            display: block
            position: absolute
            width: 4px
            height: 20px
            left: 0
            top: 4px
            background: #ff6700
          }
        }

        .live-block-row {
          margin: 30px 0 0 40px
          height: 46px
          .row-left {
            margin-right: 24px
            display: inline-block
            height: 46px
            line-height: 46px
            font-size: 18px
            color: #333333
            vertical-align: top
          }
          .selfenter-btn, .confirm-enter-btn {
            display: inline-block
            font-size: 16px
            color: #ffffff
            height: 46px
            width: 450px
            line-height: 46px
            background: #ff6700
            border-radius: 6px
            &:hover {
              background: #ff812c
            }
          }
          .confirm-enter-btn {
            width: 125px
            margin-left: 10px
          }
          .code-input {
            background-color: #fff;
            background-image: none;
            border-radius: 6px;
            border: 1px solid #a5a5a5;
            box-sizing: border-box;
            color: #ff6700;
            display: inline-block;
            font-size: 16px;
            width: 315px;
            height: 46px;
            line-height: 46px;
            text-align: center
            outline: 0;
            padding: 0 15px;
            transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
            &:-moz-placeholder {
              color: #ff6700;
            }
            &::-moz-placeholder {
              color: #ff6700;
            }
            &:-ms-input-placeholder {
              color: #ff6700;
            }
            &::-webkit-input-placeholder {
              color: #ff6700;
            }
            &:focus {
              border-color: #ff6700;
            }
          }
          .row-number-text {
            margin-left: 6px
            display: inline-block
            height: 46px
            line-height: 46px
            font-size: 18px
            color: #333333
            vertical-align: top
          }
          .scan {
            margin-left:20px
            font-size: 14px
            color: #888888
            height: 156px
            line-height: 156px
            vertical-align: top
          }
        }

        .hint {
          margin: 20px 0 0 264px
          font-size: 14px
          color: #888888
          height: 20px
          line-height: 20px
          .color {
            color: #ff6700
          }
        }
</style>



// WEBPACK FOOTER //
// src/page/account/personal/testlive/TestLive.vue